<template>
    <div>
        <template v-for="field in schema.fields">
            <component ref="field" :is="field.type" v-model="data[field.name]" :label="field.config.label"></component>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SumFieldSelector from './widget-setting-components/SumFieldSelectBox.vue'
import GroupBySelector from './widget-setting-components/GroupBySelectBox.vue'
import ArticleTypeSelector from './widget-setting-components/ArticleTypeSelectBox.vue'
import EventBaseGroupSelector from './widget-setting-components/EventGroupBaseSelectBox'
import PartnerSelectBox from './widget-setting-components/PartnerSelectBox.vue'

export default {
    props: {
        schema: {
            type: Object,
        },
        data: {
            type: Object
        }
    },
    components: {
        SumFieldSelector,
        GroupBySelector,
        ArticleTypeSelector,
        EventBaseGroupSelector,
        PartnerSelectBox
    },
    computed: {
        ...mapGetters([
			'dashboard'
		])
	},
	methods: {

	}
}
</script>